import i18n from 'src/i18n';
export let ACCOUNT_CONSTANTS = {
  setupForm: {
    header: {
      headingText: i18n.t('setUp'),
    },
    pageHeadingText: i18n.t('setAccount'),
    headingHelperText: i18n.t('setupFormHelperText'),
  },

  facilitySelection: {
    header: {
      headingText: i18n.t('primaryFacility'),
    },
    pageHeadingText: i18n.t('primaryFacility'),
    headingHelperText: i18n.t('primaryLocation'),
  },
};

export let setupContent = {
  sectionIntro: i18n.t('sectionIntro'),
  firstName: i18n.t('firstNameSmall'),
  required: i18n.t('required'),
  lastName: i18n.t('lastNameSmall'),
  phoneNumber: i18n.t('phoneNumber'),
  infoMsg: i18n.t('infoMsg'),
  accreditingId: i18n.t('accBodyID'),
  optional: i18n.t('optional'),
  placeholderEg: '1234',
  example: 'For example ARDMS-12245, ARRT-12345',
  sectionWork: i18n.t('sectionWork'),
  primaryLocation: i18n.t('primaryLocationQues'),
  linkText: i18n.t('linkText'),
  ack1: i18n.t('ack1'),
  ack2: i18n.t('ack2'),
  ack3: i18n.t('ack3'),
};

i18n.on('languageChanged', function() {
  updateTranslations();
});

function updateTranslations () {
  ACCOUNT_CONSTANTS = {
    setupForm: {
      header: {
        headingText: i18n.t('setUp'),
      },
      pageHeadingText: i18n.t('setAccount'),
      headingHelperText: i18n.t('setupFormHelperText'),
    },
  
    facilitySelection: {
      header: {
        headingText: i18n.t('primaryFacility'),
      },
      pageHeadingText: i18n.t('primaryFacility'),
      headingHelperText: i18n.t('primaryLocation'),
    },
  };
  setupContent = {
    sectionIntro: i18n.t('sectionIntro'),
    firstName: i18n.t('firstNameSmall'),
    required: i18n.t('required'),
    lastName: i18n.t('lastNameSmall'),
    phoneNumber: i18n.t('phoneNumber'),
    infoMsg: i18n.t('infoMsg'),
    accreditingId: i18n.t('accBodyID'),
    optional: i18n.t('optional'),
    placeholderEg: '1234',
    example: 'For example ARDMS-12245, ARRT-12345',
    sectionWork: i18n.t('sectionWork'),
    primaryLocation: i18n.t('primaryLocationQues'),
    linkText: i18n.t('linkText'),
    ack1: i18n.t('ack1'),
    ack2: i18n.t('ack2'),
    ack3: i18n.t('ack3'),
  };
}
